export function prepareGformFields(fields, values, formFileUploads) {
  const data = [];
  fields.map(({ id, type, inputs }) => {
    const value = values[`id_${id}`];
    // console.log("Field", id, type);
    switch (type) {
      case "NAME":
        const nameValues = {};

        const nameTypes = ["prefix", "first", "middle", "last", "suffix"];

        inputs.map(({ id: fieldId }, i) => {
          const inputValue = values[`id_${id}_${fieldId.split(".").pop()}`];

          if (inputValue) {
            nameValues[nameTypes[i]] = inputValue;
          }
        });
        data.push({
          id: id,
          nameValues: nameValues,
        });
        break;
      case "EMAIL":
        data.push({
          id: id,
          emailValues: {
            value: value,
          },
        });
        break;
      case "CHECKBOX":
        const checkboxValues =
          value &&
          value.map((value) => {
            // Checkbox input ID's are {input_id}.{sub_id}
            // Have to search fields data to get this, searching for matching text
            const matchedInput = inputs.filter(({ label }) => label === value);
            return {
              inputId: Number(matchedInput[0].id),
              value: matchedInput[0].label,
            };
          });
        data.push({
          id: id,
          checkboxValues: checkboxValues,
        });
        break;
      case "FILEUPLOAD":
        data.push({
          id: id,
          fileUploadValues: formFileUploads,
        });
        break;
      default:
        data.push({ id: id, value: value });
    }
  });

  return data;
}
